import React from 'react';
import './Miniature.css';

function Miniature(props) {
  return (
    <>
      <li>
          <figure className="miniature-wrapper">
            <img src={props.src} className="miniature-image" alt="Miniature" />
          </figure>
      </li>
    </>
  )
}

export default Miniature;
